import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropertyBox from '../home/propertyBox';
import { FiGrid } from "react-icons/fi";
import { TbLayoutList } from "react-icons/tb";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import axios from 'axios';

import emptyVideo from '../../../assets/images/empty.mp4';
import { mediaUrl, baseURL } from '../../axiosInterceptor/axiosInterceptorC';

const path = "/keralaplots/";
const BASE_URL = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/";
const BASE_URL_NOIMG = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/nophoto.jpg";

function SavedProperty() {
    const [viewMode, setViewMode] = useState("grid");
    const [isLoading, setIsLoading] = useState(true);
    const [savedProperties, setSavedProperties] = useState([]);

    useEffect(() => {
        fetchSavedProperties();
    }, []);

    const fetchSavedProperties = async () => {
        const login_id = localStorage.getItem('login_id');
        if (!login_id) return;
        
        try {
            const response = await axios.get(`${baseURL}/fetchSavedProperties`, { params: { login_id } });
            if (Array.isArray(response.data) && response.data.length > 0) {
                setSavedProperties(response.data);
            } else {
                setSavedProperties([]);
            }
        } catch (error) {
            console.error("Error fetching saved properties:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section id="savedPropertyPage">
            <div className="propertyPageHead">
                <div className="propertyPageHeadCol1">
                    <h2>Saved Properties</h2>
                </div>
                <div className="propertyPageHeadCol2">
                    <div className="gridBtn">
                        <div className={`gridBtnBox gridViewBtn ${viewMode === "grid" ? "gridBtnBoxActive" : ""}`} onClick={() => setViewMode("grid")}>
                            <FiGrid />
                        </div>
                        <div className={`gridBtnBox listViewBtn ${viewMode === "list" ? "gridBtnBoxActive" : ""}`} onClick={() => setViewMode("list")}>
                            <TbLayoutList />
                        </div>
                    </div>
                </div>
            </div>

            <div className="propertyPageMain">
                <div className="propertyPageList">
                    <div className={`propertyPageListMain ${viewMode === "list" ? "listView" : ""}`}>
                        {isLoading ? (
                            <div className='SkeletonLoader'><Skeleton count={8} /></div>
                        ) : savedProperties.length > 0 ? (
                            savedProperties.map((property) => (
                                <PropertyBox 
                                    key={property.propertyId}
                                    propertyLink={`${path}innerProperty/${property.propertyId}/${property.propertyType.replace('/', '').replace(/\s+/g, '-')}-for-${property.propertyAction}`}
                                    propertyImage={property.imageName ? `${BASE_URL}${property.imageName}` : BASE_URL_NOIMG}
                                    propertyPurposeTag={property.propertyAction} 
                                    propertyId={property.propertyId}
                                    propertyName={`${property.propertyType} For ${property.propertyAction}`} 
                                    propertyLocation={`${property.district} , ${property.town}`}
                                    propertyDate={property.addedDate}
                                    propertyPrice={property.priceVisibility === 'no' ? 'Not disclosed' : property.propertyPricerange} 
                                    propertyType={property.propertyType}
                                    savedStatus={1} 
                                />
                            ))
                        ) : (
                            <div className="emptyPage">
                                <div className="container">
                                    <div className="emptyPageMain">
                                        <div className="emptyPageBoxThumbnail">
                                            <video playsInline preload="auto" autoPlay muted loop>
                                                <source src={emptyVideo} type="video/mp4" />
                                            </video>
                                        </div>
                                        <div className="emptyPageBoxDetails">
                                            <h2 className="title">You haven’t saved anything yet!</h2>
                                            <p>You currently have no saved items. Start exploring and bookmarking your favorites to easily access them later!</p>
                                            <Link to={`${path}properties`}>Explore Properties</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SavedProperty;
